import styles from './index.module.css';

function Header() {
  return (
    <header className={styles.header}>
        <a href='/'><h1>Lossless Wax</h1></a>
        <h2>hosting the signature sounds residency</h2>
        <div className={styles.line} />
    </header>
  )
}
export default Header;